export default __webpack_public_path__ + "img/fAiFUDYH.41cc5a24.svg";